import { User } from '../../common/types';

export type UserIconProps = {
  user: User;
  color: string;
};

export function UserIcon(props: UserIconProps) {
  const { user, color } = props;
  return (
    <div
      key={user.userUuid}
      className={`rounded-full text-white flex items-center justify-center w-10 h-10 ${color}`}
      title={user.name}
    >
      {user.name[0].toUpperCase()}
    </div>
  );
}
